export const zeroTouchpointVolume = () => ({
    email: 0,
    call: 0,
    text: 0,
    visit: 0,
});
//# sourceMappingURL=marketing-plan-projection.js.map